<template>
  <div>
    <!-- 新增出行 -->
    <cube-page :title="pageTitle">
      <div slot="content">
        <div class="shopxq leopages">
          <van-form @submit="onSubmit">
            <!-- 产品选择 -->
            <van-field required readonly clickable name="product" :value="entry.product_name" label="产品"
              placeholder="点击选择产品" @click="showProductPicker"
              :rules="[{ required: true, message: '请选择产品' }]" />
            <!-- 规格选择 -->
            <van-field required readonly clickable name="sku" :value="entry.product_attr" label="规格"
              placeholder="点击选择规格" @click="showSkuPicker"
              :rules="[{ required: true, message: '请选择规格' }]" />
            <van-field required readonly clickable name="travel_time" :value="entry.travel_time" label="出行时间"
              placeholder="点击选择出行时间" @click="showTimePicker"
              :rules="[{ required: true, message: '请选择出行时间' }]" />
            <van-field v-model="entry.car_seat" clearable label="座位数" placeholder="请输入座位数" name="car_seat" required maxlength="2"
              :rules="[{ required: true, message: '请填写座位数' }]" type="number" />
            <van-field v-model="entry.car_number" clearable label="车牌号" placeholder="请输入车牌号" name="car_number" required
              :rules="[{ required: true, message: '请填写车牌号' }]" />
            <van-field v-model="entry.car_driver" clearable label="司机姓名" placeholder="请输入司机姓名" name="car_driver" required
              :rules="[{ required: true, message: '请填写司机姓名' }]" />
            <van-field v-model="entry.car_driver_tel" type="tel" clearable label="司机电话" placeholder="请输入司机电话" name="car_driver_tel" required maxlength="11"
              :rules="[
                { required: true, message: '请填写司机电话' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'onBlur' }
              ]" />
            <van-field required readonly clickable name="car_memo" :value="entry.car_memo" label="发车时间"
              placeholder="点击选择发车时间" @click="showCarMemoTime"
              :rules="[{ required: true, message: '请选择发车时间' }]" />
            <van-field v-model="entry.start_pointL" clearable label="上车点位" placeholder="多个点位用英文逗号(,)隔开" name="start_pointL" required
              maxlength="35" show-word-limit
              :rules="[{ required: true, message: '请填写上车点位' }]" />
              <div class="bottom-checkbox" v-if="isEdit">
                <div class="checkbox">
                  <van-checkbox icon-size="16px" v-model="smsNotify" shape="square" />
                </div>
                <div class="label">是否再次短信通知下单用户用车信息</div>
              </div>
              <!-- 短信模板暂时禁用 -->
            <!-- <div class="van-cell van-cell--required van-cell--clickable" @click="showSmsTplPicker">
              <div class="van-cell__title van-field__label"><span>短信模板</span></div>
              <div class="van-cell__value">
                <div v-if="smsTplNameList.length > 0" style="display:flex;flex-wrap:wrap;gap:4px;justify-content:flex-end;">
                  <van-tag v-for="(name, i) in smsTplNameList" :key="i" type="primary" size="medium">{{ name }}</van-tag>
                </div>
                <span v-else style="color:#969799;">点击选择短信模板</span>
              </div>
              <van-icon name="arrow" class="van-cell__right-icon" />
            </div> -->
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">{{ isEdit ? '保存' : '提交' }}</van-button>
            </div>
          </van-form>
        </div>
      </div>
    </cube-page>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :title="pickerTitle" show-toolbar :columns="columns" @confirm="onConfirmPicker"
        @cancel="showPicker = false" />
    </van-popup>
    <van-popup v-model="showPickerTime" position="bottom">
      <van-datetime-picker v-model="currentDate" type="date" @confirm="onConfirmTime"
        @cancel="showPickerTime = false" />
    </van-popup>
    <!-- 短信模板多选弹窗 -->
    <van-popup v-model="showSmsTplPopup" position="bottom" :style="{ height: '75%' }" get-container="body">
      <div class="sms-tpl-popup" style="display:flex;flex-direction:column;height:100%;overflow:hidden;">
        <div class="sms-tpl-header" style="flex:0 0 auto;display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-bottom:1px solid #ebedf0;">
          <van-button size="small" @click="cancelSmsTpl">取消</van-button>
          <span style="font-size:16px;font-weight:bold;">选择短信模板</span>
          <van-button size="small" type="info" @click="confirmSmsTpl">确定</van-button>
        </div>
        <div class="sms-tpl-list" style="flex:1 1 auto;padding:12px 16px;overflow-y:scroll;-webkit-overflow-scrolling:touch;">
          <div v-for="(tpl, index) in smsTplOptions" :key="tpl.id" style="margin-bottom:12px;border-bottom:1px solid #f5f5f5;padding-bottom:8px;">
            <van-checkbox v-model="tpl.checked" style="margin-bottom:8px;">
              {{ tpl.name }}
            </van-checkbox>
            <div style="font-size:12px;color:#999;padding-left:28px;line-height:1.5;">{{ tpl.content }}</div>
            <div v-if="tpl.checked && tpl.keywords && tpl.keywords.length > 0" style="padding-left:28px;">
              <van-field v-for="kw in tpl.keywords" :key="kw.key" v-model="tpl.params[kw.key]" :label="kw.title"
                :placeholder="kwPlaceholder(kw)" :readonly="kw.rule === 'time'" :clickable="kw.rule === 'time'"
                @click="kw.key === 'date' ? showSmsParamDate(index) : (kw.key === 'time' ? showSmsParamTime(index) : null)" size="small" />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 短信模板参数-日期选择 -->
    <van-popup v-model="showSmsTplDatePicker" position="bottom">
      <van-datetime-picker v-model="smsTplCurrentDate" type="date" @confirm="onConfirmSmsTplDate"
        @cancel="showSmsTplDatePicker = false" />
    </van-popup>
    <!-- 短信模板参数-时间选择 -->
    <van-popup v-model="showSmsTplTimePicker" position="bottom">
      <van-datetime-picker v-model="smsTplCurrentTime" type="time" @confirm="onConfirmSmsTplTime"
        @cancel="showSmsTplTimePicker = false" />
    </van-popup>
    <!-- 发车时间选择 -->
    <van-popup v-model="showCarMemoTimePicker" position="bottom">
      <van-datetime-picker v-model="carMemoCurrentTime" type="time" @confirm="onConfirmCarMemoTime"
        @cancel="showCarMemoTimePicker = false" />
    </van-popup>
  </div>
</template>

<script>
import {
  Toast
} from 'vant';
import CubePage from '@/components/TP/cube-page.vue'
import * as util from '@/utils/network'
import * as udate from '@/utils/date'
// 旧版 sms_text 关键字 key 到新版 keywords key 的兼容映射
const LEGACY_KEYWORD_KEY_MAP = {
  car_number: 'car_no',
};
export default {
  components: {
    CubePage,
  },
  data() {
    return {
      item: this.$route.params.item,
      entry: {
        product_id: "",
        product_name: "",
        spec_sku_id: "",
        product_attr: "",
        travel_time: "",
        car_seat: "",
        car_number: "",
        car_driver: "",
        driver_uid: "",
        car_driver_tel: "",
        car_memo: "",
        start_pointL: "",
        sms_tpl: "",
        sms_tpl_name: "",
        sms_text: "",
      },
      productList: [],
      skuList: [],
      showPicker: false,
      pickerType: '',
      pickerTitle: '',
      columns: [],
      showPickerTime: false,
      currentDate: new Date(),
      getSmsTpl: [],
      // 短信模板多选
      showSmsTplPopup: false,
      smsTplOptions: [],
      showSmsTplDatePicker: false,
      smsTplCurrentDate: new Date(),
      smsTplDateIndex: -1,
      showSmsTplTimePicker: false,
      smsTplCurrentTime: '12:00',
      smsTplTimeIndex: -1,
      showCarMemoTimePicker: false,
      carMemoCurrentTime: '12:00',
      editId: '',
      smsNotify: true,
    }
  },
  created() {
    this.editId = this.$route.query.id || '';
    if (this.isEdit) {
      this.fetchDetail();
    } else {
      this.getSmsTplData();
      this.getTravelProductList();
    }

  },
  computed: {
    isEdit() {
      return !!this.editId;
    },
    pageTitle() {
      return this.isEdit ? '编辑出行' : '新增出行';
    },
    smsTplNameList() {
      return this.entry.sms_tpl_name ? this.entry.sms_tpl_name.split('\uFF0C') : [];
    }
  },
  watch: {
    'entry.travel_time'(val) {  //日期
      this.syncSmsParam('date', val);
    },
    'entry.product_attr'(val) { //行程
      this.syncSmsParam('line_name', val);
      this.syncSmsParam('line', val);       // 兼容
    },
    'entry.car_number'(val) { //车牌号
      this.syncSmsParam('car_no', val);
      this.syncSmsParam('car_number', val); // 兼容
    },
    'entry.car_driver'(val) { //司机
      this.syncSmsParam('driver', val);
    },
    'entry.car_memo'(val) { //发车时间
      this.syncSmsParam('time', val);
    },
    'entry.start_pointL'(val) { //上车地点
      this.syncSmsParam('address', val);
    },
  },
  methods: {
    onSubmit(values) {
      // if (!this.entry.sms_tpl) {
      //   Toast('请选择短信模板');
      //   return;
      // }
      let url = '/addons/litestore/api.supplier/travelAdd';
      const data = {
        // 只读字段从 entry 补充
        product_id: this.entry.product_id,
        product_name: this.entry.product_name,
        spec_sku_id: this.entry.spec_sku_id,
        product_attr: this.entry.product_attr,
        travel_time: this.entry.travel_time,
        // 输入字段从 values 获取
        car_seat: values.car_seat,
        car_number: values.car_number,
        car_driver: values.car_driver,
        // driver_uid: values.driver_uid,
        car_driver_tel: values.car_driver_tel,
        car_memo: this.entry.car_memo,
        // 字段名映射：start_pointL -> start_point
        start_point: values.start_pointL,
        // 短信模板数据
        //sms_tpl: this.entry.sms_tpl,
        //sms_text: JSON.parse(this.entry.sms_text || '{}'),
        sendSms: this.smsNotify,
      };
      if (this.isEdit) {
        data.id = this.editId;
        url = '/addons/litestore/api.supplier/travelSave';
      }
      //console.log('data', data);
      util.post(url, data,
        (result) => {
          Toast.success(result.msg);
          if(result.code === 1) {
            //Toast.success('操作成功');
            setTimeout(() => {
              this.$router.go(-1);
            }, 800);
          }
        },
      );
    },
    getTravelProductList() {
      var url = "/addons/litestore/api.supplier/getGoodsList"
      let that = this;
      //这里直接调用网络接口
      util.post(url, {},
        function (result) {
          that.productList = result;

        },
      );
    },
    fetchDetail() {
      const id = this.editId;
      util.get('/addons/litestore/api.supplier/travelSave', { id },
        (result) => {
          const d = result.data || result;
          this.entry.product_id = d.product_id || '';
          this.entry.product_name = d.product_name || '';
          this.entry.spec_sku_id = d.spec_sku_id || '';
          this.entry.product_attr = d.product_attr || '';
          this.entry.travel_time = d.travel_time || '';
          this.entry.car_seat = d.car_seat || '';
          this.entry.car_number = d.car_number || '';
          this.entry.car_driver = d.car_driver || '';
          this.entry.car_driver_tel = d.car_driver_tel || '';
          this.entry.car_memo = d.car_memo || '';
          this.entry.start_pointL = d.start_point || '';
          this.smsNotify = d.sendSms || false;
          // 加载产品列表和规格列表用于回显
          this.getTravelProductList();
          this.getTravelSkuList(d.product_id);
          // 加载短信模板并回显
          this.getSmsTplData(() => {
            const smsText = typeof d.sms_text === 'string' ? JSON.parse(d.sms_text || '{}') : (d.sms_text || {});
            this.restoreSmsTpl(d.sms_tpl, smsText);
          });
        },
      );
    },
    restoreSmsTpl(smsTplStr, smsTextObj) {
      if (!smsTplStr) return;
      const ids = smsTplStr.split(',').map(Number);
      const options = this.getSmsTpl.map(item => {
        const isSelected = ids.includes(item.id);
        const smsItem = smsTextObj[item.code] || {};
        return {
          id: item.id,
          name: item.name,
          code: item.code,
          content: item.content,
          keywords: item.keywords,
          checked: isSelected,
          params: item.keywords
            ? item.keywords.reduce((obj, kw) => {
                const legacyKey = LEGACY_KEYWORD_KEY_MAP[kw.key];
                const val = smsItem[kw.key] !== undefined ? smsItem[kw.key] : (legacyKey ? smsItem[legacyKey] : '');
                obj[kw.key] = (isSelected && val) ? val : '';
                return obj;
              }, {})
            : {},
        };
      });
      this.smsTplOptions = options;
      const selected = options.filter(t => t.checked);
      this.entry.sms_tpl = selected.map(t => t.id).join(',');
      this.entry.sms_tpl_name = selected.map(t => t.name).join('，');
      const smsText = {};
      for (const tpl of selected) {
        const obj = { code: tpl.code };
        if (tpl.keywords) {
          Object.assign(obj, tpl.params);
        }
        smsText[tpl.code] = obj;
      }
      this.entry.sms_text = JSON.stringify(smsText);
    },
    getTravelSkuList(id) {
      var url = "/addons/litestore/api.supplier/getGoodsSkuList"
      let that = this;
      //这里直接调用网络接口
      util.post(url, { goods_id: id },
        function (result) {
          that.skuList = result;
        },
      );
    },
    showProductPicker() {
      this.pickerType = 'product';
      this.pickerTitle = '选择产品';
      this.columns = this.productList;
      this.showPicker = true;
    },
    showSkuPicker() {
      if (!this.entry.product_id) {
        Toast('请先选择产品');
        return;
      }
      this.pickerType = 'sku';
      this.pickerTitle = '选择规格';
      this.columns = this.skuList;
      this.showPicker = true;
    },
    onConfirmPicker(val) {
      if (this.pickerType === 'product') {
        this.entry.product_id = val.value;
        this.entry.product_name = val.text;
        this.entry.spec_sku_id = '';
        this.entry.product_attr = '';
        this.entry.sms_tpl = '';
        this.entry.sms_tpl_name = '';
        this.entry.sms_text = '';
        this.smsTplOptions = [];
        this.skuList = [{ text: '规格选择', value: '' }];
        this.getTravelSkuList(val.value);
      } else if (this.pickerType === 'sku') {
        this.entry.spec_sku_id = val.value;
        this.entry.product_attr = val.text;
      }
      this.showPicker = false;

    },
    getSmsParamValue(key) {
      if (this.isEdit) return '';
      const map = {
        date:       this.entry.travel_time,
        line_name:  this.entry.product_attr,   // 行程(新key)
        line:       this.entry.product_attr,   // 兼容：有些模板可能仍用 line
        car_no:     this.entry.car_number,     // 车牌号(新key)
        car_number: this.entry.car_number,     // 兼容：旧 key
        driver:     this.entry.car_driver,
        time:       this.entry.car_memo,
        address:    this.entry.start_pointL,
      };
      return map[key] || '';
    },
    syncSmsParam(key, val) {
      if (this.isEdit) return;
      this.smsTplOptions.forEach(tpl => {
        if (tpl.params && Object.prototype.hasOwnProperty.call(tpl.params, key)) {
          this.$set(tpl.params, key, val || '');
        }
      });
    },
    showSmsTplPicker() {
      // if (!this.entry.product_id) {
      //   Toast('请先选择产品');
      //   return;
      // }
      // 构建选项列表，保留之前已选中的状态
      const prevSelected = {};
      this.smsTplOptions.forEach(t => {
        if (t.checked) prevSelected[t.id] = t;
      });
      this.smsTplOptions = this.getSmsTpl.map(item => {
        const prev = prevSelected[item.id];
        return {
          id: item.id,
          name: item.name,
          code: item.code,
          content: item.content,
          keywords: item.keywords,
          checked: prev ? prev.checked : false,
          params: prev ? prev.params : (item.keywords ? item.keywords.reduce((obj, kw) => { obj[kw.key] = this.getSmsParamValue(kw.key); return obj; }, {}) : {})
        };
      });
      this.showSmsTplPopup = true;

      //新增：弹窗打开后，把当前已填写的表单字段同步到所有模板 params
      this.syncAllSmsParams();
    },
    syncAllSmsParams() {
      this.syncSmsParam('date',       this.entry.travel_time);
      this.syncSmsParam('line_name',  this.entry.product_attr);
      this.syncSmsParam('line',       this.entry.product_attr);
      this.syncSmsParam('car_no',     this.entry.car_number);
      this.syncSmsParam('car_number', this.entry.car_number);
      //司机变量处理
      let driver_text = '';
      if (this.entry.car_driver_tel != ''){
        //截取手机号中间四位
        const driver_tel_text_mid = this.entry.car_driver_tel.substring(3, 7);
        //将手机号driver_tel_text中间四位用*替换
        const driver_tel_text_mask = String(this.entry.car_driver_tel).replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
        //合并司机和司机手机号
        driver_text = this.entry.car_driver + '(' + driver_tel_text_mask + '，请添加中间'+driver_tel_text_mid+')';
      }

      this.syncSmsParam('driver',     driver_text);
      this.syncSmsParam('time',       this.entry.car_memo);
      this.syncSmsParam('address',    this.entry.start_pointL);
    },
    cancelSmsTpl() {
      this.showSmsTplPopup = false;
    },
    confirmSmsTpl() {
      const selected = this.smsTplOptions.filter(t => t.checked);
      if (selected.length === 0) {
        Toast('请至少选择一个短信模板');
        return;
      }
      // 校验必填参数
      for (const tpl of selected) {
        if (tpl.keywords) {
          for (const kw of tpl.keywords) {
            if (!tpl.params[kw.key]) {
              Toast(`请填写"${tpl.name}"的内容`);
              return;
            }
          }
        }
      }
      // 构建 entry 数据
      this.entry.sms_tpl = selected.map(t => t.id).join(',');
      this.entry.sms_tpl_name = selected.map(t => t.name).join('，');
      const smsText = {};
      for (const tpl of selected) {
        const obj = { code: tpl.code };
        if (tpl.keywords) {
          Object.assign(obj, tpl.params);
        }
        smsText[tpl.code] = obj;
      }
      this.entry.sms_text = JSON.stringify(smsText);
      this.showSmsTplPopup = false;
    },
    kwLabel(kw) {
      const map = { date: '日期', time: '时间', car: '车牌号', driver: '司机', phone: '手机号' };
      return map[kw] || kw;
    },
    kwPlaceholder(kw) {
      if(kw.rule === 'time'){
        return '点击选择日期或时间';
      }else {
        return '请输入' + kw.title;
      }
    },
    showSmsParamDate(index) {
      this.smsTplDateIndex = index;
      const val = this.smsTplOptions[index].params.date;
      this.smsTplCurrentDate = val ? new Date(val) : new Date();
      this.showSmsTplDatePicker = true;
    },
    onConfirmSmsTplDate(value) {
      if (this.smsTplDateIndex >= 0) {
        this.smsTplOptions[this.smsTplDateIndex].params.date = udate.getFormatDate(value, 'yyyy-mm-dd');
      }
      this.showSmsTplDatePicker = false;
      this.smsTplDateIndex = -1;
    },
    showSmsParamTime(index) {
      this.smsTplTimeIndex = index;
      const val = this.smsTplOptions[index].params.time;
      this.smsTplCurrentTime = val || '12:00';
      this.showSmsTplTimePicker = true;
    },
    onConfirmSmsTplTime(value) {
      if (this.smsTplTimeIndex >= 0) {
        this.smsTplOptions[this.smsTplTimeIndex].params.time = value;
      }
      this.showSmsTplTimePicker = false;
      this.smsTplTimeIndex = -1;
    },
    showTimePicker() {
      this.showPickerTime = true;
    },
    onConfirmTime(value) {
      this.entry.travel_time = udate.getFormatDate(value, 'yyyy-mm-dd');
      this.currentDate = new Date(value);
      this.showPickerTime = false;
    },
    showCarMemoTime() {
      this.carMemoCurrentTime = this.entry.car_memo || '12:00';
      this.showCarMemoTimePicker = true;
    },
    onConfirmCarMemoTime(value) {
      this.entry.car_memo = value;
      this.showCarMemoTimePicker = false;
    },
    getSmsTplData(callback) {
      // var url = "/addons/litestore/api.supplier/getSmsTpl"
      // util.post(url, {},
      //   (result) => {
      //     this.getSmsTpl = result;
      //     callback && callback();
      //   },
      // );
      //this.getSmsTpl = [{"id":338,"name":"凭证获取","code":"SMS_490740194","content":"您的订单已安排，请前往小程序“智旅惠游”，获取使用凭证","keywords":null,"type_text":"","status_text":""},{"id":336,"name":"签约通知(新)","code":"SMS_490820155","content":"为保障您的权益，请前往小程序“智旅惠游”进行《跟团游合同》签署，祝旅途愉快","keywords":null,"type_text":"","status_text":""},{"id":317,"name":"九寨沟-黄龙行程","code":"SMS_485355336","content":"${date}九寨沟-黄龙景区 ${time}发车，上车地点如下: 1.星宇酒店 2.润都国际温泉酒店 3.月亮湾停车场 4.桔子酒店 5.千古情对面 6. 鲁能小镇（搜索将军超市） 车牌号:${car}，司机电话:${driver}。请选择距您最近的站点提前10分钟前往候车。 温馨提示:若携带儿童出行，儿童必须购票占座。若您有任何问题，可联系客服:${phone} 。祝您旅途愉快!","keywords":["date","time","car","driver","phone"],"type_text":"","status_text":""},{"id":307,"name":"九寨沟接站","code":"SMS_484040060","content":" ${date}黄龙九寨站-九寨沟行程已安排 ${time}发车，上车地点：出站口上手扶梯或者上楼梯后右转,直行到大巴车停车场上车 车牌号:${car}，司机:${driver}。 温馨提示:若携带儿童出行,儿童必须购票占座。回程预约，景区门票，晚会演出等请关注公众号：九旅旅游，可联系客服:${phone} 。祝您旅途愉快!","keywords":["date","time","car","driver","phone"],"type_text":"","status_text":""},{"id":306,"name":"九寨沟送站","code":"SMS_483790114","content":"${date}九寨沟-黄龙九寨站 ${time}发车，上车地点如下: 1.星宇酒店 2.润都国际温泉酒店  3.月亮湾停车场 4.桔子酒店 5.千古情对面 6. 鲁能小镇（搜索将军超市） 车牌号:${car}，司机:${driver}。请选择距您最近的站点提前10分钟前往候车。 温馨提示:若携带儿童出行，儿童必须购票占座。若您有任何问题，可联系客服:${phone} 。祝您旅途愉快!","keywords":["date","time","car","driver","phone"],"type_text":"","status_text":""},{"id":268,"name":"签约通知","code":"SMS_475245445","content":"为保障您的权益，请点此链接签署《跟团游合同》 https:\/\/www.jonlv.com\/jonlv\/v2\/signing ，祝旅途愉快","keywords":null,"type_text":"","status_text":""}]
     // console.log('this.getSmsTpl111', this.getSmsTpl);
    },
  }

}
</script>
<style lang="less" scoped>
.leopages {
  background-color: #fff;
}
.sms-tpl-list {
  .van-field--readonly {
    background-color: #f7f8fa;
  }
}
.bottom-checkbox {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  .label {
    margin-left: 15px;
  }
}
</style>
